var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoading)?_c('Spinner'):_c('div',[_c('LotteryResultToday',{attrs:{"result":_vm.result},on:{"switch-region":_vm.switchRegion}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }